import { render, staticRenderFns } from "./UploadInstr.vue?vue&type=template&id=78cc3ebb&scoped=true&"
import script from "./UploadInstr.vue?vue&type=script&lang=js&"
export * from "./UploadInstr.vue?vue&type=script&lang=js&"
import style0 from "./UploadInstr.vue?vue&type=style&index=0&id=78cc3ebb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cc3ebb",
  null
  
)

export default component.exports